import { graphql, useStaticQuery } from "gatsby";

const getAllEvents = () => useStaticQuery(graphql`
    {
      events: allKontentItemEvent(sort: {elements: {date_start: {value: DESC}}}) {
        nodes {
           ...EventTileCard
        }
      }
    }
  `);

export default getAllEvents;
